<!--  意见反馈申请页面-->
<template>
  <div class="feedback_div">
    <div>
      <p>学校联系电话：{{ userInfo.departPhone }}</p>
      <a-form-model
        ref="formRef"
        :rules="rules"
        :model="formData"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="反馈类型" prop="leaveType">
          <j-dict-select-tag
            type="select"
            v-model="formData.leaveType"
            dictCode="leave_msg_type"
            placeholder="请选择"
          />
        </a-form-model-item>
        <a-form-model-item label="联系电话" prop="phone">
          <a-input
            v-model.trim="formData.phone"
            placeholder="请输入联系电话"
            allowClear
          />
        </a-form-model-item>
        <a-form-model-item label="联系邮箱" prop="email">
          <a-input
            v-model.trim="formData.email"
            placeholder="请输入联系邮箱"
            allowClear
          />
        </a-form-model-item>
        <a-form-model-item label="反馈内容" prop="content">
          <a-textarea
            v-model="formData.content"
            placeholder="请尽量详细描写您要反馈的意见内容，方便为您处理(200字符以内)"
            :rows="5"
            :maxLength="200"
            showCount
          />
        </a-form-model-item>
        <a-form-model-item label="附加图片">
          <div>
            <a-upload
              :action="axios.defaults.baseURL + '/common/upload'"
              list-type="picture-card"
              :file-list="fileList"
              @preview="handlePreview"
              @change="handleChange"
              accept="image/jpeg,image/png"
              :before-upload="beforeUpload"
            >
              <div v-if="fileList.length < 5">
                <a-icon type="plus" />
                <div class="ant-upload-text">上传图片</div>
              </div>
            </a-upload>
            <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
              <img alt="example" style="width: 100%" :src="previewImage" />
            </a-modal>
          </div>
        </a-form-model-item>
        <!-- 上传附件 -->
      </a-form-model>
      <a-button
        type="primary"
        class="btn btn-info"
        :loading="loading"
        style="margin-left: 150px"
        @click="handleSubmit"
      >
        提交
      </a-button>
    </div>
  </div>
</template>

<script>
import ChangeUpload from '../ChangeUpload.vue'
import {mapState} from 'vuex'
const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

export default {
  name: 'FeedbackApply',
  components: {
    ChangeUpload
  },
  data: function() {
    return {
      loading: false,
      formData: {
        leaveType: null, // 反馈类型
        phone: null, // 联系电话
        email: null, // 联系邮箱
        content: null // 反馈内容
      },
      previewVisible: false,
      previewImage: '',
      urlList: [],
      fileList: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 }
      },
      rules: {
        leaveType: [{ required: true, message: '反馈类型不能为空' }],
        phone: [
          { required: true, message: '联系电话不能为空' },
          { validator: this.validatePhone, trigger: 'blur' }
        ],
        email: [{ validator: this.validateEmail, trigger: 'blur' }],
        content: [{ required: true, message: '反馈内容不能为空' }]
      }
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    validatePhone(rule, value, callback) {
      const phoneRegex = /^1[3-9]\d{9}$/
      if (!value) {
        callback(new Error('联系电话不能为空'))
      } else if (!phoneRegex.test(value)) {
        callback(new Error('联系电话格式不正确'))
      } else {
        callback() // 通过校验
      }
    },
    validateEmail(rule, value, callback) {
      if (!value) {
        callback()
      } else {
        if (!emailRegex.test(value)) {
          callback(new Error('请输入有效的邮箱地址'))
        } else {
          callback()
        }
      }
    },
    // 文件上传前校验
    beforeUpload(file) {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        this.$message.error("只能上传png和jpg格式的图片！");
        setTimeout(() => {}, 1000);
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("只能上传小于2MB的图片！");
        return false;
      }
      return isJpgOrPng && isLt2M;
    },
    // 取消上传
    handleCancel() {
      this.previewVisible = false;
    },
    // 图片预览
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    // 获取文件编码
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    // 上传成功
    handleChange(info) {
      this.fileList = info.fileList;
      if (info.file.response !== undefined) {
        if (info.file.response.code === 200) {
          if (info.file.status === "done") {
            this.$message.success(info.file.response.message);
            this.urlList.push(info.file.response.result);
          } else {
            this.urlList = this.urlList.filter(item => {
              return item !== info.file.response.result;
            });
          }
        } else {
          this.$message.error(info.file.response.message);
          this.fileList.pop();
        }
      }
    },
    // 页面提交
    handleSubmit() {
      if (this.formData.email) {
        if (!emailRegex.test(this.formData.email)) {
          this.$message.error('请输入有效的邮箱地址')
          return
        }
      }
      this.$refs.formRef.validate(valid => {
        if (valid) {
          this.submit();
        } else {
          this.$message.error("表单必填项校验失败");
          return false;
        }
      });
    },
    // 反馈提交
    submit() {
      const that = this;
      that.loading = true;
      // 将字符串分割成数组
      if (that.urlList && that.urlList.length > 0) {
        that.formData.urls = that.urlList.join(",");
      }

      let params = {
        type: 0,
        ...that.formData
      };
      that.axios
        .post(`/biz/user/feedback`, params)
        .then(res => {
          if (res.success) {
            that.$message.success("提交成功，感谢您的反馈");
            that.formData = {};
            that.fileList = [];
            that.urlList = [];
          } else {
            that.$message.success("提交失败");
          }
        })
        .finally(() => {
          that.loading = false;
        });
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.feedback_div {
  display: flex;
  background: #fff;
  padding: 28px;
  padding-top: 24px;
  margin-top: 20px;
  position: relative;

  /deep/ p {
    margin-bottom: 16px;
    font-weight: bolder;
  }
  /deep/ .ant-form {
    width:600px;
  }
  /deep/ .ant-form-item {
    margin-bottom: 2px;
  }
}
.btn {
  background: $bgColor;
  color: #fff;
  width: 120px;
  margin: 20px 0;
}

.btn-info {
  background: $bgColor;
  border: 1px solid $bgColor;
}

.btn-text {
  color: #c4c4c4;
  display: block;
  margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/feedback/apply.vue